import {
  KeyCommentContainer,
  ParagraphSectionLayout,
  ParagraphTitle,
} from "@frontend/common";

import { DEALS_PARAGRAPH_CODE } from "@EditArticleContainer/shared/constants/editArticle.constants";
import { useParagraphEditedData } from "@EditArticleContainer/shared/hooks/useParagraph";
import { useUpdateParagraph } from "@EditArticleContainer/shared/hooks/useUpdateParagraph";
import {
  REF_CODE_KEY_COMMENTS_LIST_QUOTE,
  REF_CODE_KEY_COMMENTS_LIST_SPOKESPERSON,
} from "@EditArticleContainer/shared/libs/refCode/constants/refCode.constants";
import { createRefCode } from "@EditArticleContainer/shared/libs/refCode/utils/createRefCode";

import * as S from "../DealsParagraphKeyCommentsList/DealsParagraphKeyCommentsList.style";

const PARAGRAPH_TITLE = "Key Comments";

// NOTE: LA(Deal LA&SC) 카테고리의 Key Comments 다중 표출.
// MA 의 TC126 리스트(DealsParagraphKeyCommentsList)를 미러하되, Deal LA&SC Key Comment List 인 TC127 을 바라본다.
const DealsParagraphKeyCommentsListLASC = () => {
  const paragraph = useParagraphEditedData(
    DEALS_PARAGRAPH_CODE.keyCommentsListLASC,
  );
  const [updateParagraph, loadingIndex, updateKeyMap] = useUpdateParagraph({
    paragraphCode: DEALS_PARAGRAPH_CODE.keyCommentsListLASC,
    sectionCode: "TY002",
  });

  if (!paragraph) return null;

  const keyCommentList = paragraph.text["Key Comment List"];

  if (keyCommentList.length === 0) return null;

  return (
    <ParagraphSectionLayout>
      <ParagraphTitle title={PARAGRAPH_TITLE} />
      <S.ParagraphKeyCommentsListWrapper key={updateKeyMap.get(0)}>
        <S.ParagraphKeyCommentsListUpdateButton
          disabled={loadingIndex === 0}
          onClick={() => updateParagraph(0)}
        />
        <S.CommentsListWrapper>
          {keyCommentList.map((item, index) => (
            <KeyCommentContainer
              key={`key-comment-list-${String(index)}`}
              quote={
                <S.QuoteContent
                  item={{
                    text: item["Comment Quote"].value.at(0)?.text ?? "",
                    labels: (item["Comment Quote"].value.at(0)?.labels ??
                      []) as [],
                  }}
                  canTextEdit
                  canLabelEdit
                  refKey={createRefCode(
                    REF_CODE_KEY_COMMENTS_LIST_QUOTE,
                    index,
                  )}
                  style={{ padding: "0.4rem" }}
                />
              }
              spokesperson={
                <S.SpokespersonContent
                  item={{
                    text: item["Comment Spokesperson"].value.at(0)?.text ?? "",
                    labels: (item["Comment Spokesperson"].value.at(0)?.labels ??
                      []) as [],
                  }}
                  canTextEdit
                  canLabelEdit
                  refKey={createRefCode(
                    REF_CODE_KEY_COMMENTS_LIST_SPOKESPERSON,
                    index,
                  )}
                  style={{ padding: "0.4rem" }}
                />
              }
            />
          ))}
        </S.CommentsListWrapper>
      </S.ParagraphKeyCommentsListWrapper>
    </ParagraphSectionLayout>
  );
};

export default DealsParagraphKeyCommentsListLASC;
